import { Agent } from './agent';
import { Attachment } from './attachment';
import { Context } from './context';
import { Group } from './group';
import { Result } from './result';
import { StatementRef } from './statement_ref';
import { SubStatement } from './sub_statement';
import { Utils } from '../utils';
import { Verb } from './verb';
import { Activity } from './activity';
export class Statement {
    id;
    timestamp;
    stored;
    version;
    originalJson;
    objectType = 'Statement';
    _actor;
    _authority;
    _verb;
    _context;
    _result;
    _target;
    attachments;
    constructor(cfg, initCfg = { storeOriginal: 2, doStamp: true }) {
        const { storeOriginal, doStamp } = initCfg;
        if (typeof cfg === 'string') {
            const sp = this.fromJSON(cfg);
            if (storeOriginal) {
                sp.originalJson = JSON.stringify(cfg, undefined, storeOriginal);
            }
            if (doStamp) {
                sp.stamp();
            }
            return sp;
        }
        if (storeOriginal) {
            this.originalJson = JSON.stringify(cfg, undefined, storeOriginal);
        }
        this.actor = this.agent_group(cfg.actor);
        this.authority = this.agent_group(cfg.authority);
        this.verb = this.fix_verb(cfg.verb);
        this.target = this.fix_target(cfg.object ? cfg.object : cfg.target);
        this.result = this.fix_result(cfg.result);
        this.context = this.fix_context(cfg.context);
        if (cfg.attachments) {
            this.attachments = cfg.attachments.map((att) => {
                if (att instanceof Attachment) {
                    return att;
                }
                return new Attachment(att);
            });
        }
        this.id = cfg.id;
        this.stored = cfg.stored;
        this.timestamp = cfg.timestamp;
        this.version = cfg.version || '1.0.3';
        if (doStamp) {
            this.stamp();
        }
    }
    agent_group(value) {
        if (value === undefined) {
            return undefined;
        }
        if (value.objectType === undefined || value.objectType === 'Person') {
            value.objectType = 'Agent';
        }
        if (value.objectType === 'Agent') {
            if (value instanceof Agent) {
                return value;
            }
            else {
                return new Agent(value);
            }
        }
        else if (value.objectType === 'Group') {
            if (value instanceof Group) {
                return value;
            }
            else {
                return new Group(value);
            }
        }
    }
    get actor() {
        return this._actor;
    }
    set actor(value) {
        this._actor = this.agent_group(value);
    }
    get authority() {
        return this._authority;
    }
    set authority(value) {
        this._authority = this.agent_group(value);
    }
    fix_verb(value) {
        return value && (value instanceof Verb ? value : new Verb(value));
    }
    get verb() {
        return this._verb;
    }
    set verb(value) {
        this._verb = value;
    }
    fix_context(value) {
        return value && (value instanceof Context ? value : new Context(value));
    }
    get context() {
        return this._context;
    }
    set context(value) {
        this._context = value;
    }
    fix_result(value) {
        return value && (value instanceof Result ? value : new Result(value));
    }
    get result() {
        return this._result;
    }
    set result(value) {
        this._result = value;
    }
    fix_target(value) {
        if (value === undefined) {
            return undefined;
        }
        let target = undefined;
        if (value instanceof Activity ||
            value instanceof Agent ||
            value instanceof Group ||
            value instanceof SubStatement ||
            value instanceof StatementRef) {
            target = value;
        }
        else {
            if (typeof value.objectType === 'undefined') {
                value.objectType = 'Activity';
            }
            if (value.objectType === 'Activity') {
                target = new Activity(value);
            }
            else if (value.objectType === 'Agent') {
                target = new Agent(value);
            }
            else if (value.objectType === 'Group') {
                target = new Group(value);
            }
            else if (value.objectType === 'SubStatement') {
                target = new SubStatement(value);
            }
            else if (value.objectType === 'StatementRef') {
                target = new StatementRef(value);
            }
        }
        return target;
    }
    get target() {
        return this._target;
    }
    set target(value) {
        this._target = value;
    }
    toString(lang = 'en-US') {
        return `${this.actor !== undefined ? this.actor.toString() : ''} ${this.verb !== undefined ? this.verb.toString(lang) : ''} ${this.target !== undefined ? this.target.toString(lang) : ''}`;
    }
    asVersion(version = '1.0.3') {
        const { id, timestamp, actor, verb, result, context, authority, target } = this;
        const stmnt = {
            id,
            timestamp,
            actor: actor?.asVersion(),
            verb: verb?.asVersion(),
            result: result?.asVersion(),
            context: context?.asVersion(),
            authority: authority?.asVersion(),
            object: target?.asVersion()
        };
        if (this.attachments) {
            stmnt.attachments = this.attachments.map((att) => {
                if (att instanceof Attachment) {
                    return att.asVersion(version);
                }
                return new Attachment(att).asVersion(version);
            });
        }
        return stmnt;
    }
    stamp() {
        if (!this.id) {
            this.id = Utils.getUUID();
        }
        if (!this.timestamp) {
            this.timestamp = Utils.isoNow;
        }
    }
    hasAttachmentWithContent() {
        if (!this.attachments) {
            return false;
        }
        for (let i = 0; i < this.attachments.length; i += 1) {
            if (this.attachments[i].content !== null) {
                return true;
            }
        }
        return false;
    }
    fromJSON(stJSON) {
        const _st = JSON.parse(stJSON);
        return new Statement(_st);
    }
}
